import React, {useEffect, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import anexoAcontecimentoStyle from "../../assets/jss/material-dashboard-pro-react/components/anexoAcontecimentoStyle";
import {DropzoneAreaBase} from 'material-ui-dropzone'
import ReactTable from "../../components/ReactTableWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchPlus, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";

const AnexoAcontecimento = (props) => {
  const {classes} = props;

  const id_acontecimento = props.id_acontecimento;

  const [anexos, setAnexos] = useState([]);

  useEffect(() => {
    connection.get(`acontecimento/anexo_acontecimento/${id_acontecimento}/listagem`).then(setAnexos)
  }, []);

  const apagarAnexo = (id) => {
    props.setModal(<SweetAlert
      warning
      title="Remover Importação"
      onConfirm={async () => {
        await connection.post(`acontecimento/anexo_acontecimento/${id}/apagar`);
        connection.get(`acontecimento/anexo_acontecimento/${id_acontecimento}/listagem`).then(setAnexos);
        props.setModal(null)
      }}
      onCancel={() => props.setModal(null)}
      confirmBtnCssClass={
        classes.button + " " + classes.danger
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Apagar"
      cancelBtnText="Cancelar"
      showCancel
    >
      Quer apagar a importação com o ID {id}?
    </SweetAlert>)
  }

  return <div>
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Novo anexo</h4>
            </div>
          </CardHeader>
          <DropzoneAreaBase
            filesLimit={1}
            maxFileSize={5 * 1024 * 1024} // 5MB
            dropzoneText={"Arraste ficheiro para adicionar um novo anexo"}
            onAdd={async (files) => {
              let form_data = new FormData();
              form_data.append("ficheiro", files[0].file);
              await connection.post(`acontecimento/anexo_acontecimento/${id_acontecimento}/adicionar`, form_data);
              connection.get(`acontecimento/anexo_acontecimento/${id_acontecimento}/listagem`).then(setAnexos);
              general.success("Anexo adicionado com sucesso")
            }}
            onDropRejected={() => {
              general.error("Ocorreu um erro ao adicionar o anexo, por favor verifique que o ficheiro tem menos de 5MB")
            }}
            showAlerts={false}
            fileObjects={[]}
            classes={{root: classes.dropzoneRoot}}/>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Anexos</h4>
            </div>
          </CardHeader>
          <ReactTable
            placeholder={"Ainda não foi adicionado nenhum anexo"}
            data={anexos}
            minRows={1}
            columns={[
              {
                Header: "Data de Criação",
                accessor: "data",
                Cell: ({value}) => general.Renderers.dateRenderer(value, {hide_timezone: true})
              },
              {
                Header: "Utilizador",
                accessor: "criado_por",
                width: 150,
                Cell: general.Renderers.userRenderer
              },
              {
                Header: "Informação",
                accessor: "informacoes_ficheiro",
                Cell: ({value}) => {
                  let dados = JSON.parse(value);
                  return dados.name;
                }
              },
              {
                Header: "Tipo",
                accessor: "informacoes_ficheiro",
                Cell: ({value}) => {
                  let dados = JSON.parse(value);
                  return dados.mimetype.split('/').pop();
                }
              },
              {
                Header: "",
                maxWidth: 105,
                sortable: false,
                filterable: false,
                Cell: ({original}) => <React.Fragment>
                  <Button
                    justIcon
                    round
                    simple
                    onClick={() => {
                      window.open(connection.getFullUrl(original.path))
                    }}
                    style={{margin: 0}}
                    color="info"
                    className="edit"
                  >
                    <FontAwesomeIcon icon={faSearchPlus}/>
                  </Button>
                  {!original.data_finalizacao && <Button
                    justIcon
                    round
                    simple
                    style={{margin: 0}}
                    onClick={() => {
                      apagarAnexo(original.id)
                    }}
                    color="danger"
                    className="edit"
                  >
                    <FontAwesomeIcon icon={faTrashAlt}/>
                  </Button>}
                </React.Fragment>
              }
            ]}
            defaultPageSize={10}
            showPaginationBottom={true}
            className="-striped -highlight"
          />
        </Card>
      </GridItem>
    </GridContainer>
  </div>;
}

export default withStyles(anexoAcontecimentoStyle)(AnexoAcontecimento);
